import {
  BACKOFFICE_LEAD_STATUS,
  BACKOFFICE_LEAD_STATUS_ERROR,
  CLEAN_BACKOFFICE_LEAD_STATUS,
  CLEAN_BACKOFFICE_LEAD_STATUS_ERROR,
} from '_models/redux/types';

const initialState = {
  loaded: undefined,
  method: undefined,
  payload: undefined,
  status: undefined,
  state: undefined,
};

export default function backofficeLeadStatusReducer(state = initialState, action) {
  switch (action.type) {
    case BACKOFFICE_LEAD_STATUS:
      return {
        ...state,
        loaded: true,
        method: action?.method || null,
        payload: action?.payload || {},
        status: action?.status || null,
        state: 'success',
      };

    case BACKOFFICE_LEAD_STATUS_ERROR:
      return {
        ...state,
        loaded: true,
        payload: action?.payload || {},
        status: action?.status || null,
        state: 'error',
      };

    case CLEAN_BACKOFFICE_LEAD_STATUS:
      return {
        ...state,
        loaded: false,
        payload: action?.payload || undefined,
        status: undefined,
        state: 'success',
      };

    case CLEAN_BACKOFFICE_LEAD_STATUS_ERROR:
      return {
        ...state,
        loaded: false,
        payload: action?.payload || undefined,
        status: undefined,
        state: 'error',
      };
    default:
      return state;
  }
}
